import React, { useEffect, useState } from "react";
import moment from "moment";
import toast from "react-hot-toast";
import { Button, Form, Select } from "antd";
import Edit from "../../../assets/Edit.jsx";
import Add from "../../../assets/Add.jsx";
import Send from "../../../assets/Send.jsx";
import columns from "../../../columns/emailTemplate/emailTemplate.js";
import SkeletonTable from "../../../components/table/SkeletonTable.jsx";
import {
  GetEmailTemplateListApi,
  SendMailApi,
} from "../../../api/request/emailTemplate/emailTemplate.js";
import { GetClientsApi } from "../../../api/request/clients/clients.js";
import TemplateForm from "./components/TemplateForm.jsx";
import ModalComponent from "../../../components/modals/ModalComponent.jsx";
import LoadableButton from "../../../components/buttons/LoadableButton.jsx";

const { Option } = Select;

const EmailTemplate = () => {
  const [sendMailForm] = Form.useForm();
  const [templateList, setTemplateList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [mode, setMode] = useState("view");
  const [selectedTemplate, setSelectedTemplate] = useState({});
  const [userList, setUserList] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [isSendMail, setIsSendMail] = useState(false);
  const [isSendMailLoading, setIsSendMailLoading] = useState(false);

  const getEmailTemplateList = async () => {
    try {
      setIsLoading(true);
      const { data } = await GetEmailTemplateListApi();
      if (data?.status) {
        setTemplateList(
          data?.data?.map((item) => {
            return {
              ...item,
              created_at: item?.created_at
                ? moment(item?.created_at).format("LL")
                : "",
              action: (
                <div className="flex items-center gap-5">
                  <div
                    className="cursor-pointer"
                    onClick={() => {
                      setSelectedTemplate(item);
                      setMode("edit");
                    }}
                  >
                    <Edit />
                  </div>
                  <div
                    className="cursor-pointer"
                    onClick={() => {
                      setSelectedTemplate(item);
                      setIsSendMail(true);
                    }}
                  >
                    <Send />
                  </div>
                </div>
              ),
            };
          })
        );
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  const getUserList = async () => {
    try {
      const { data } = await GetClientsApi();
      if (data.status) {
        const userData = data?.data?.map((item) => {
          return { id: item?.id, name: item?.name };
        });
        setUserList(userData);
      }
    } catch (error) {}
  };

  useEffect(() => {
    getEmailTemplateList();
    getUserList();
  }, []);

  const onSendMail = async () => {
    if (!selectedTemplate?.id) return;
    try {
      setIsSendMailLoading(true);
      const params = {
        email_temp_id: selectedTemplate?.id,
        users: selectedUsers,
      };
      const { data } = await SendMailApi(params);
      if (data.status) {
        setIsSendMailLoading(false);
        toast.success(data.message);
        sendMailForm.resetFields();
        setIsSendMail(false);
      }
    } catch (error) {
      if (error?.response?.data?.message)
        toast.error(error?.response?.data?.message);
      setIsSendMailLoading(false);
    }
  };

  return (
    <div className="mb-6">
      <div className="border-2 rounded-xl">
        {mode === "view" && (
          <>
            <div className="flex justify-between mx-5 gap-5 mt-4">
              <p className="font-semibold text-xl">Email Templates</p>
              <Button
                type="primary"
                size="large"
                icon={<Add />}
                onClick={() => {
                  setSelectedTemplate({});
                  setMode("add");
                }}
              >
                Add Template
              </Button>
            </div>
            <div className="table-radius-0 text-light my-4">
              <SkeletonTable
                searchingFields={["template_name", "subject"]}
                dateFilterFields={["created_at"]}
                columns={columns}
                data={templateList}
                isLoading={isLoading}
              />
            </div>
          </>
        )}

        {["add", "edit"].includes(mode) && (
          <TemplateForm
            mode={mode}
            setMode={setMode}
            selectedTemplate={selectedTemplate}
            setSelectedTemplate={setSelectedTemplate}
            getEmailTemplateList={getEmailTemplateList}
          />
        )}
      </div>

      <ModalComponent
        isOpen={isSendMail}
        setIsOpen={setIsSendMail}
        title="Send Mail"
      >
        <Form
          className="w-full flex flex-col gap-3"
          autoComplete="off"
          form={sendMailForm}
          initialValues={{ users: [] }}
          onFinish={onSendMail}
        >
          <Form.Item
            name="users"
            className="my-2"
            rules={[{ required: true, message: "Please select users!" }]}
          >
            <Select
              mode="multiple"
              allowClear
              placeholder="Select users"
              size="large"
              onChange={(value) => setSelectedUsers(value)}
              filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
              }
            >
              <Option
                value="all"
                disabled={
                  selectedUsers.length > 0 && !selectedUsers.includes("all")
                }
              >
                All
              </Option>
              {userList.map((user) => (
                <Option
                  key={user.id}
                  value={user.id}
                  disabled={selectedUsers.includes("all")}
                >
                  {user.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <div className="text-center mt-2">
            <LoadableButton
              className="bg-primary text-sm text-white font-medium px-8 py-2 rounded-lg themeHover duration-500"
              type="submit"
              lable="Send Mail"
              isLoading={isSendMailLoading}
              loadingLable="Sending Mail..."
            />
          </div>
        </Form>
      </ModalComponent>
    </div>
  );
};

export default EmailTemplate;
